import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faFileExcel } from '@fortawesome/pro-regular-svg-icons';
import ReactTooltip from 'react-tooltip';
import css from './excel-button.module.css';

interface Props {
  onClick: () => void;
  id?: string;
}

export default function ExcelButton({ onClick, id = null }: Props) {
  const { t } = useTranslation();
  return (
    <div id={id} className={css['container']}>
      <div
        onClick={onClick}
        className={`${css['export-button']} ${css['export-icon']}`}
        data-tip
        data-for="export_to_excel_tooltip"
      >
        <FontAwesomeIcon icon={faArrowDown} className={css['small']} />
        <FontAwesomeIcon icon={faFileExcel} className={css['big']} />
        <ReactTooltip
          id="export_to_excel_tooltip"
          backgroundColor={'#002A58'}
          place="top"
          effect="solid"
        >
          {t('export_to_excel')}
        </ReactTooltip>
      </div>
    </div>
  );
}
